/**
 * 🔴 GENERATED BY `scripts/gen-screen-modules.mjs` — DO NOT EDIT.
 *
 * Which module each back-office screen and route belongs to, read off the server's own
 * `@RequiresModule` decorators rather than guessed from names. Run
 * `node scripts/gen-screen-modules.mjs` to rewrite it; `--check` fails when it is stale.
 *
 * ⚠️ **THIS DECIDES WHAT IS SHOWN, NOT WHAT IS ALLOWED.** `ModuleGuard` on the server is the gate.
 * A screen in the wrong group here is a dead link or a missing one — never an open door.
 *
 * 🔬 Screens by module: banking 5, core 84, crm 5, fixed_assets 3, group 1, inventory 14, manufacturing 1, payroll 14, pos 2, projects 4, purchasing 14, sales 4, storefront 1, subscriptions 1.
 */
export type ScreenModule = string;

export const SCREEN_MODULES: Readonly<Record<string, ScreenModule>> = {
  "Accounts": 'core',
  "Activities": 'crm',
  "ActivityTypes": 'projects',
  "Aging": 'core',
  "AllocationPicker": 'core', // override
  "Approvals": 'core',
  "Attendance": 'payroll',
  "AuditLog": 'core',
  "BalanceSheet": 'core',
  "BankStatement": 'banking', // override
  "BankStatements": 'banking',
  "Bill": 'core',
  "BillCreate": 'core',
  "BillEdit": 'core',
  "Bills": 'core',
  "BlanketOrder": 'purchasing',
  "BlanketOrders": 'purchasing',
  "Boms": 'manufacturing',
  "BranchBalanceSheet": 'core',
  "BranchProfitAndLoss": 'core',
  "ConsolidatedStatements": 'group',
  "Construction": 'projects', // override
  "Conversion": 'core',
  "Couriers": 'sales',
  "CreditNote": 'core',
  "CreditNoteCreate": 'core',
  "CreditNoteEdit": 'core',
  "CreditNotes": 'core',
  "Dashboard": 'core',
  "DepreciationRuns": 'fixed_assets',
  "DeviceEnrolment": 'payroll', // override
  "EmployeePlacement": 'payroll',
  "Employees": 'payroll',
  "Expense": 'core',
  "ExpenseCreate": 'core',
  "ExpenseEdit": 'core',
  "Expenses": 'core',
  "ExportLcs": 'purchasing',
  "FixedAsset": 'fixed_assets',
  "FixedAssets": 'fixed_assets',
  "FollowUps": 'crm',
  "Funds": 'core', // override
  "GeneralLedger": 'core',
  "GoodsReceipt": 'purchasing',
  "GoodsReceiptCreate": 'purchasing', // override
  "GoodsReceipts": 'purchasing',
  "GroupDashboard": 'core',
  "Holidays": 'payroll',
  "InterBranchTransfer": 'core',
  "Invoice": 'core',
  "InvoiceCreate": 'core',
  "InvoiceEdit": 'core',
  "Invoices": 'core',
  "Items": 'inventory',
  "Journal": 'core',
  "JournalDraft": 'core',
  "JournalDraftForm": 'core',
  "JournalDrafts": 'core',
  "Journals": 'core',
  "LandedCost": 'purchasing',
  "LandedCosts": 'purchasing',
  "Leads": 'crm',
  "LetterOfCredit": 'purchasing',
  "LettersOfCredit": 'purchasing',
  "LoansFines": 'payroll',
  "Marketplace": 'sales',
  "ModuleDisabled": 'core', // override
  "MyPayslips": 'payroll',
  "Nominees": 'payroll', // override
  "OperatorTrail": 'core',
  "OrderBook": 'sales',
  "Organisation": 'payroll',
  "OwnerSummary": 'core',
  "Partner360": 'core', // override
  "PartnerDocumentExpiry": 'crm',
  "Partners": 'core',
  "Payment": 'core',
  "PaymentCreate": 'core',
  "PaymentEdit": 'core', // override
  "Payments": 'core',
  "PayrollInputs": 'payroll',
  "PayrollRun": 'payroll',
  "PayrollRuns": 'payroll',
  "Periods": 'core',
  "Pharma": 'inventory',
  "Pipeline": 'crm',
  "PostDatedCheque": 'banking',
  "PostDatedChequeCreate": 'banking',
  "PostDatedCheques": 'banking',
  "ProfitAndLoss": 'core',
  "Project": 'projects',
  "Projects": 'projects',
  "PurchaseOrder": 'purchasing',
  "PurchaseOrderCreate": 'purchasing', // override
  "PurchaseOrders": 'purchasing',
  "ReceivedNotBilled": 'purchasing',
  "RecurringCosts": 'core',
  "Registers": 'pos', // override
  "ReorderReport": 'inventory',
  "Reports": 'core', // override
  "SalesDashboard": 'sales',
  "Sessions": 'pos',
  "Settings": 'core', // override
  "SettingsAccounts": 'core',
  "SettingsApiTokens": 'core', // override
  "SettingsApprovals": 'core',
  "SettingsCompany": 'core',
  "SettingsCustomFields": 'core',
  "SettingsDocuments": 'core',
  "SettingsMembers": 'core',
  "SettingsNumbering": 'core',
  "SettingsPortal": 'core',
  "SettingsPreferences": 'core',
  "SettingsWebhooks": 'core',
  "SettingsWorkflowRules": 'core',
  "Shifts": 'payroll',
  "Statement": 'core', // override
  "StockAdjustment": 'inventory',
  "StockAdjustments": 'inventory',
  "StockCount": 'inventory',
  "StockCounts": 'inventory',
  "StockDashboard": 'inventory',
  "StockExpiry": 'inventory',
  "StockMovement": 'inventory',
  "StockTie": 'core',
  "StockTransfer": 'inventory',
  "StockTransfers": 'inventory',
  "StockValuation": 'inventory',
  "StorePayments": 'storefront',
  "Subscriptions": 'subscriptions',
  "TaxCodes": 'core',
  "Tracking": 'inventory',
  "TrialBalance": 'core',
  "TurnoverReturn": 'core',
  "TurnoverTaxAdjustment": 'core',
  "TurnoverTaxAdjustmentForm": 'core',
  "TurnoverTaxAdjustments": 'core',
  "Users": 'core',
  "VatAdjustment": 'core',
  "VatAdjustmentForm": 'core',
  "VatAdjustments": 'core',
  "VatByPlace": 'core',
  "VatReturn": 'core',
  "VatStandingCard": 'core',
  "VatSummary": 'core',
  "WageBoards": 'payroll',
  "bill-form": 'core',
  "expense-form": 'core',
  "invoice-form": 'core',
  "journal-form": 'core',
  "report-shell": 'core', // override
  "sale-tax-code": 'core',
  "settings-shell": 'core', // override
};

/**
 * 🔴 THE SAME ANSWER, KEYED BY ROUTE — what the nav filters on and what the route guard reads.
 *
 * ⚠️ A path ABSENT here is treated as always-visible by its callers, and that is the safe direction
 * on purpose: a missing entry shows a link whose API will refuse it, while a WRONG entry hides
 * something the customer paid for.
 *
 * 🔧 1 route(s) resolve to no screen module and are therefore always
 * visible: /module-disabled (ModuleDisabledScreen).
 */
export const ROUTE_MODULES: Readonly<Record<string, ScreenModule>> = {
  "/": 'core',
  "/invoices": 'core',
  "/invoices/new": 'core',
  "/invoices/$invoiceId": 'core',
  "/invoices/$invoiceId/edit": 'core',
  "/bills/new": 'core',
  "/bills": 'core',
  "/bills/$billId": 'core',
  "/bills/$billId/edit": 'core',
  "/purchase-orders/new": 'purchasing',
  "/purchase-orders": 'purchasing',
  "/purchase-orders/$orderId": 'purchasing',
  "/goods-receipts": 'purchasing',
  "/goods-receipts/$receiptId": 'purchasing',
  "/purchase-orders/$orderId/receive": 'purchasing',
  "/post-dated-cheques/new": 'banking',
  "/post-dated-cheques": 'banking',
  "/post-dated-cheques/$chequeId": 'banking',
  "/fixed-assets": 'fixed_assets',
  "/fixed-assets/$assetId": 'fixed_assets',
  "/depreciation": 'fixed_assets',
  "/export-lcs": 'purchasing',
  "/blanket-orders": 'purchasing',
  "/blanket-orders/$agreementId": 'purchasing',
  "/letters-of-credit": 'purchasing',
  "/letters-of-credit/$creditId": 'purchasing',
  "/landed-costs": 'purchasing',
  "/landed-costs/$voucherId": 'purchasing',
  "/stock-transfers": 'inventory',
  "/stock-transfers/$transferId": 'inventory',
  "/pharma": 'inventory',
  "/reports/stock-expiry": 'inventory',
  "/reports/reorder": 'inventory',
  "/dashboards/stock": 'inventory',
  "/dashboards/sales": 'sales',
  "/reports/consolidated": 'group',
  "/reports/stock-valuation": 'inventory',
  "/reports/stock-tie": 'core',
  "/reports/stock-movement": 'inventory',
  "/tracking": 'inventory',
  "/conversion": 'core',
  "/stock-counts": 'inventory',
  "/stock-counts/$countId": 'inventory',
  "/stock-adjustments": 'inventory',
  "/stock-adjustments/$adjustmentId": 'inventory',
  "/periods": 'core',
  "/payroll": 'payroll',
  "/payroll/$runId": 'payroll',
  "/recurring-costs": 'core',
  "/projects": 'projects',
  "/projects/$projectCode": 'projects',
  "/activity-types": 'projects',
  "/construction": 'projects',
  "/employees": 'payroll',
  "/organisation": 'payroll',
  "/shifts": 'payroll',
  "/attendance": 'payroll',
  "/holidays": 'payroll',
  "/wage-boards": 'payroll',
  "/my-payslips": 'payroll',
  "/loans-fines": 'payroll',
  "/approvals": 'core',
  "/audit-log": 'core',
  "/operator-activity": 'core',
  "/bank": 'banking',
  "/bank/$statementId": 'banking',
  "/accounts": 'core',
  "/tax-codes": 'core',
  "/users": 'core',
  "/settings": 'core',
  "/pos/registers": 'pos',
  "/pos/sessions": 'pos',
  "/settings/company": 'core',
  "/settings/numbering": 'core',
  "/settings/accounts": 'core',
  "/settings/approvals": 'core',
  "/settings/members": 'core',
  "/settings/portal": 'core',
  "/settings/preferences": 'core',
  "/settings/custom-fields": 'core',
  "/settings/documents": 'core',
  "/settings/workflow-rules": 'core',
  "/settings/api-tokens": 'core',
  "/settings/webhooks": 'core',
  "/items": 'inventory',
  "/funds": 'core',
  "/journals": 'core',
  "/journals/$journalId": 'core',
  "/reports": 'core',
  "/reports/trial-balance": 'core',
  "/reports/profit-and-loss": 'core',
  "/reports/balance-sheet": 'core',
  "/group": 'core',
  "/boms": 'manufacturing',
  "/store-payments": 'storefront',
  "/subscriptions": 'subscriptions',
  "/marketplace": 'sales',
  "/couriers": 'sales',
  "/reports/vat-by-place": 'core',
  "/summary": 'core',
  "/ledger/inter-branch-transfer": 'core',
  "/reports/general-ledger": 'core',
  "/reports/vat-return": 'core',
  "/reports/turnover-return": 'core',
  "/reports/statements": 'core',
  "/reports/received-not-billed": 'purchasing',
  "/reports/aging": 'core',
  "/reports/vat-summary": 'core',
  "/payments": 'core',
  "/payments/new": 'core',
  "/payments/$paymentId": 'core',
  "/payments/$paymentId/edit": 'core',
  "/credit-notes": 'core',
  "/credit-notes/new": 'core',
  "/credit-notes/$noteId": 'core',
  "/credit-notes/$noteId/edit": 'core',
  "/expenses": 'core',
  "/expenses/new": 'core',
  "/expenses/$claimId": 'core',
  "/expenses/$claimId/edit": 'core',
  "/journal-drafts": 'core',
  "/journal-drafts/new": 'core',
  "/journal-drafts/$draftId": 'core',
  "/journal-drafts/$draftId/edit": 'core',
  "/vat-adjustments": 'core',
  "/vat-adjustments/new": 'core',
  "/vat-adjustments/$adjustmentId": 'core',
  "/turnover-tax-adjustments": 'core',
  "/turnover-tax-adjustments/new": 'core',
  "/turnover-tax-adjustments/$adjustmentId": 'core',
  "/vat-adjustments/$adjustmentId/edit": 'core',
  "/leads": 'crm',
  "/activities": 'crm',
  "/pipeline": 'crm',
  "/partners/$code": 'core',
  "/reports/follow-ups": 'crm',
  "/reports/partner-document-expiry": 'crm',
  "/reports/order-book": 'sales',
  "/partners": 'core',
};
